<template>
    <div>
        <div class="form-field form-field--tree form-field--tree-not-nowrap" style="padding-bottom: 8px">
            <label>{{ label }}
                <span v-if="required" class="required">*</span></label>
            <treeselect v-model="country" :multiple="false" :options="countries_options" :clearOnSelect="true" />
            <div class="form-field--not-applicable" v-if="not_applicable">
                <div class="checkbox">
                    <div class="form-field checkbox-wrap">
                        <input type="checkbox" v-model="is_not_applicable" :id="`${id}_not_applicable`"
                            :name="`${name}_not_applicable`" @change="onChangeIsNotApplicable" />
                        <label :for="`${id}_not_applicable`">
                            <i class="icon icon-checkmark"></i>
                        </label>
                        Not applicable
                    </div>
                </div>
            </div>
            <span class="error" :style="'bottom: -12px'" v-if="error">{{
                error
            }}</span>
        </div>
        <div class="form-field form-field--tree form-field--tree-not-nowrap">
            <label>State </label>
            <treeselect v-model="state" :multiple="false" :options="states" :clearOnSelect="true"
                :disabled="!is_has_states" />
        </div>
    </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
    name: "Country_Widget",
    data() {
        return {
            country: null,
            state: null,
            states: [],
            is_not_applicable: false,
        };
    },
    computed: {
        countries_options() {
            return this.countries.length
                ? this.countries.map((country) => ({
                    id: country.id,
                    label: country.name,
                }))
                : [];
        },
        is_has_states() {
            return this.states.length ? true : false;
        },
    },
    components: {
        Treeselect,
    },
    props: [
        "id",
        "label",
        "name",
        "required",
        "setHasErrors",
        "onChange",
        "defaultValue",
        "countries",
        "error",
        "custom",
        "not_applicable",
        "default_country",
    ],
    mounted() {
        if (this.defaultValue) {
            this.country = this.defaultValue.country.value || null;
            this.state = this.defaultValue.state.value || null;
        } else if (this.default_country) {
            this.country = this.default_country;
        }
    },
    watch: {
        country: function (val) {
            this.onGetStates(this.country);
            if (this.country === this.defaultValue.country.value) {
                return
            }
            this.state = null;
            this.onChange(this.name, {
                country: {
                    value: this.country,
                    not_applicable: false,
                },
                state: {
                    value: null,
                    not_applicable: false,
                },
            });
        },
        state: function (val) {
            this.onChange(this.name, {
                country: {
                    value: this.country,
                    not_applicable: false,
                },
                state: {
                    value: this.state,
                    not_applicable: false,
                },
            });
        },
    },

    methods: {
        async onGetStates(country_id = null) {
            this.states = [];
            if (!country_id) {
                console.error("Country id is required");
            }
            await axios
                .post("/agencies/address/getStatesByCountry", {
                    countryId: country_id,
                })
                .then((r) => {
                    this.states = r.data;
                });
        },
        onChangeIsNotApplicable(e) {
            if (e.target.checked) {
                this.is_not_applicable = true;
                this.onChange(this.name, {
                    country: {
                        value: null,
                        not_applicable: this.is_not_applicable,
                    },
                    state: {
                        value: null,
                        not_applicable: this.is_not_applicable,
                    },
                });

                this.value = null;
            } else {
                this.is_not_applicable = false;
            }
        },
    },
};
</script>
